import { Component, OnDestroy } from '@angular/core';
import { ModalOptions, ModalService, ModalType } from '@ipreo/ngx-sprinkles';
import { ExportService } from '../../../services/export.service';
import { ExportReportModalComponent } from '../export-report-modal/export-report-modal.component';

const MODAL_OPTIONS: ModalOptions = {
  type: ModalType.View,
  view: ExportReportModalComponent,
  inputs: { width: 600 },
  title: 'Export Reports'
};

@Component({
  selector: 'muni-gameday-export-report-icon',
  templateUrl: './export-report-icon.template.html',
  styleUrls: ['./export-report-icon.styles.scss'],
  standalone: false
})
export class ExportReportIconComponent implements OnDestroy {
  public readonly isVisible = this.exportService.isExportAllowed$;

  constructor(
    private exportService: ExportService,
    private modalService: ModalService
  ) {
    this.exportService.subscribe();
  }

  public ngOnDestroy(): void {
    this.exportService.unsubscribe();
  }

  public openModal(): void {
    this.modalService.create(MODAL_OPTIONS);
  }
}
